import { FC, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/pro-solid-svg-icons/faCheck";
import { faCopy } from "@fortawesome/pro-solid-svg-icons/faCopy";
import Translated from "../infrastructure/translation/Translated";
import { useTranslate } from "../infrastructure/translation/useTranslate";
import { TranslationKey } from "../infrastructure/translation/translator";
import styles from "./ClientPage.module.css";

const CONFIRMATION_MS = 2000;

export const CopyButton: FC<{ value: string; labelKey: TranslationKey }> = ({
  value,
  labelKey,
}) => {
  const [copied, setCopied] = useState(false);
  const translate = useTranslate();

  useEffect(() => {
    if (!copied) return;

    const timer = setTimeout(() => setCopied(false), CONFIRMATION_MS);
    return () => clearTimeout(timer);
  }, [copied]);

  const copy = () => {
    navigator.clipboard?.writeText(value).then(
      () => setCopied(true),
      () => {},
    );
  };

  const label = translate(labelKey);

  return (
    <button
      type="button"
      onClick={copy}
      className={styles.copyButton}
      aria-label={label}
      title={label}
    >
      <FontAwesomeIcon icon={copied ? faCheck : faCopy} aria-hidden />
      <span className={styles.srOnly} aria-live="polite">
        {copied && <Translated textKey={"client.copied"} />}
      </span>
    </button>
  );
};
